var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9985 11.9999C13.9985 9.05554 14.0007 6.11121 13.9976 3.16733C13.9958 1.65525 12.9806 0.400562 11.4926 0.0729313C11.2727 0.0245056 11.0418 0.00444031 10.8162 0.00400352C8.27546 -0.000795364 5.73517 -0.000797272 3.19444 0.00182152C1.41205 0.00356483 0.00376926 1.39 0.00288798 3.15686C-0.000637138 9.05248 -0.000637138 14.9485 0.00288798 20.8442C0.0042099 22.6102 1.41338 23.9975 3.19488 23.9988C5.73561 24.0005 8.2759 24.0009 10.8166 23.9988C12.5836 23.997 13.9936 22.6084 13.9972 20.8546C14.0029 17.9033 13.9989 14.9516 13.9989 12.0003L13.9985 11.9999ZM0.929112 19.0511V5.68935H13.0749V19.0511H0.929112ZM0.911487 4.79982C0.911487 4.24969 0.910605 3.72051 0.911487 3.19176C0.914131 1.88647 1.87649 0.899645 3.19092 0.893538C5.73076 0.882195 8.27017 0.881758 10.81 0.893538C12.1147 0.899645 13.0833 1.88516 13.0877 3.17126C13.0894 3.64372 13.0877 4.1162 13.0877 4.58823C13.0877 4.65716 13.0877 4.72609 13.0877 4.79982H0.911927H0.911487ZM13.0886 19.9385C13.0886 20.2369 13.0886 20.5117 13.0886 20.787C13.0864 22.1399 12.1134 23.1071 10.7417 23.1088C8.25298 23.1123 5.76425 23.111 3.27508 23.1079C3.0856 23.1079 2.89128 23.0953 2.70709 23.0547C1.35036 22.7563 0.555009 21.3432 0.9485 19.9385H13.0881H13.0886Z",
    fill: "#B27D52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98569 1.26634C6.12468 1.27202 5.41965 1.97876 5.42582 2.83034C5.43199 3.68715 6.13613 4.37601 7.00331 4.37426C7.86961 4.37296 8.57287 3.67886 8.57419 2.82379C8.57551 1.96218 7.86036 1.26067 6.98569 1.26634ZM7.00199 3.68017C6.52257 3.68105 6.13217 3.3015 6.12688 2.82903C6.12159 2.36049 6.51156 1.96741 6.98701 1.96174C7.47435 1.95607 7.87534 2.34696 7.87313 2.8251C7.87093 3.2967 7.48096 3.6793 7.00199 3.68017Z",
    fill: "#B27D52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00639 21.9108C7.86519 21.9108 8.72356 21.9134 9.58237 21.9095C9.91197 21.9081 10.1133 21.6608 10.038 21.3659C9.98643 21.1635 9.81414 21.047 9.548 21.0457C8.9831 21.043 8.41776 21.0448 7.85286 21.0448C6.72262 21.0448 5.59238 21.0439 4.46214 21.0457C4.16382 21.0461 3.98316 21.184 3.95408 21.4213C3.91927 21.707 4.11051 21.909 4.43041 21.9099C5.28922 21.9125 6.14758 21.9108 7.00639 21.9108Z",
    fill: "#B27D52"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: -0.65,
    width: 12.7,
    height: 22.7,
    rx: 2.35,
    transform: "matrix(1 0 0 -1 0.000244141 22.7)",
    stroke: "#B27D52",
    strokeWidth: 1.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 24,
    rx: 3,
    transform: "matrix(1 0 0 -1 0.000244141 24)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.821c887190e1da27163bf253d36dfc39.svg";
export { ForwardRef as ReactComponent };